import Card, { CardDescription, CardHeader } from '../../components/Card';
import { Integration } from '../../types/settings';

interface IntegrationItem {
    name: string;
    icon: string;
    type: Integration;
}

const INTEGRATIONS: IntegrationItem[] = [
    { name: 'Bubble', icon: '/images/integrations/bubble-io.png', type: Integration.BUBBLE },
    { name: 'PayPal', icon: '/images/integrations/paypal.png', type: Integration.PAYPAL },
    { name: 'Rewardful', icon: '/images/integrations/rewardful.png', type: Integration.REWARDFUL },
];

interface Props {
    onConfigure: (integration: Integration) => void;
}

export default function ConfigurationsList({ onConfigure }: Props) {
    const handleClick = (type: Integration) => () => onConfigure(type);
    return (
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {INTEGRATIONS.map(({ name, icon, type }) => (
                <Card key={name}>
                    <CardHeader onClick={handleClick(type)}>
                        <img src={icon} className="h-24 w-auto mx-auto pt-4" alt={`PriceWell ${name} integration`} />
                    </CardHeader>
                    <CardDescription
                        title={
                            <button
                                onClick={handleClick(type)}
                                className="font-medium text-lg inline-block mb-2 hover:text-blue-400"
                            >
                                {name} Integration
                            </button>
                        }
                    />
                </Card>
            ))}
        </div>
    );
}
